import { motion } from "framer-motion";
import { CalendarClock } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { Countdown } from "./Countdown";

const HERO_IMG = "/images/sawyer-5.webp";

export const Hero = () => (
  <section data-testid="hero-section" className="bg-cream overflow-hidden">
    <div className="max-w-6xl mx-auto px-6 pt-20 pb-24 grid lg:grid-cols-12 gap-12 items-center">
      <motion.div
        className="lg:col-span-7"
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7 }}
      >
        <p data-testid="hero-eyebrow" className="font-accent text-2xl sm:text-3xl text-clay mb-4">
          a free live masterclass
        </p>
        <h1
          data-testid="hero-title"
          className="font-heading text-5xl sm:text-6xl lg:text-7xl tracking-tight leading-[1.02] text-ink"
        >
          How to Build a Personal Brand People Actually <span className="whitespace-nowrap">Care About</span>
        </h1>
        <p data-testid="hero-subhead" className="mt-6 text-lg text-stone-text max-w-xl leading-relaxed">
          For Christian women in fitness + wellness who feel called to become creators, build an audience + turn what they love into something bigger.
        </p>
        <div
          data-testid="hero-datetime"
          className="mt-8 inline-flex items-center gap-2 rounded-full border border-line bg-white px-4 py-2 text-sm text-stone-text"
        >
          <CalendarClock className="h-4 w-4 text-sage" />
          Live · Tuesday, September 22 · 7:00 PM ET · Free
        </div>
        <div className="mt-8">
          <CtaButton testId="hero-cta-button">Save My Free Seat</CtaButton>
          <Countdown />
        </div>
      </motion.div>
      <motion.div
        className="lg:col-span-5"
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, delay: 0.15 }}
      >
        <img
          data-testid="hero-image"
          src={HERO_IMG}
          alt="Sawyer Fast, your webinar host"
          className="rounded-2xl object-cover aspect-[4/5] w-full shadow-[0_20px_40px_rgb(0,0,0,0.08)]"
        />
      </motion.div>
    </div>
  </section>
);
